export interface ZendeskConversationField {
	id: string;
	value: string;
}

export const ZENDESK_FIELD_IDS = {
	organization: "48757383658651",
} as const;

const ZENDESK_KEY = "b5e17cb2-511a-4aa1-8c38-7324caa75204";

let loadPromise: Promise<void> | null = null;

let shouldOpen = false;

function getZE(): Function | undefined {
	return ((window as unknown) as Record<string, Function>).zE;
}

function loadZendeskScript(): Promise<void> {
	if (window.Zendesk) return Promise.resolve();
	if (loadPromise) return loadPromise;

	loadPromise = new Promise((resolve, reject) => {
		const settings = document.createElement("script");
		settings.textContent = `
			window.zESettings = {
				messenger: { launcher: { visible: false } }
			};
		`;
		document.head.appendChild(settings);

		const script = document.createElement("script");
		script.id = "ze-snippet";
		script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
		script.defer = true;
		script.onload = () => {
			const zE = getZE()!;

			zE("messenger:set", "cookies", true);
			zE("messenger", "close");

			const style = document.createElement("style");
			style.textContent = `
				iframe#launcher,
				iframe[title*="launch" i] { display: none !important; }
			`;
			document.head.appendChild(style);

			window.Zendesk = {
				open: () => zE("messenger", "open"),
				close: () => zE("messenger", "close"),
				set: (field, value) => zE("messenger:set", field, value),
			};
			resolve();
		};
		script.onerror = () => {
			loadPromise = null;
			reject(new Error("Zendesk script failed to load"));
		};
		document.head.appendChild(script);
	});

	return loadPromise;
}

export async function openZendeskChat(fields?: ZendeskConversationField[]) {
	shouldOpen = true;
	await loadZendeskScript();

	if (!shouldOpen) return;

	const zE = getZE();
	if (!zE) return;

	if (fields?.length) {
		zE("messenger:set", "conversationFields", fields);
	}

	zE("messenger", "open");
}

export function closeZendeskChat() {
	shouldOpen = false;
	const zE = getZE();
	if (zE) {
		zE("messenger", "close");
	}
}
